import { isInsuranceBookingProtectionEnabledForCurrentRegion } from 'checkout/selectors/request/isBookingProtectionAvailable'
import { Experiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'
import { useAppSelector } from 'hooks/reduxHooks'

/**
 * Whether bedbank flex packages (a non-refundable rate bundled with a CFMR quote) are offered.
 *
 * `canTrigger` carries the caller's own conditions (non-refundable rate, dates). On top of those,
 * the experiment only activates, and its CFMR quote is only requested, in a region svc-insurance
 * quotes CFMR for: every other origin is rejected, and the room option would spin on a quote that
 * can never arrive.
 */
function useFlexCfmrBedbankPackagesExperiment(canTrigger: boolean): boolean {
  const isBookingProtectionRegion = useAppSelector(isInsuranceBookingProtectionEnabledForCurrentRegion)
  const canActivate = isBookingProtectionRegion && canTrigger
  const { isAnyVariant } = useExperiment(Experiments.croFlexCfmrBedbankPackages, { canActivate })
  return canActivate && isAnyVariant
}

export default useFlexCfmrBedbankPackagesExperiment
